// extracted by mini-css-extract-plugin
export var pager = "pager-module--pager--2d02f";
export var rightAlign = "pager-module--rightAlign--445ce";